var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientIconPills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2469 20.2905C15.2469 17.5253 17.4886 15.2837 20.2538 15.2837C22.7605 15.2837 24.837 17.1258 25.2033 19.5301C25.0193 19.5559 24.8355 19.5856 24.6521 19.6192L24.5442 19.6389C22.4265 20.0268 21.1559 22.2145 21.8683 24.2461L22.1121 24.9415C21.5381 25.1711 20.9113 25.2974 20.2538 25.2974C17.4886 25.2974 15.2469 23.0558 15.2469 20.2905ZM22.6765 26.551C21.9245 26.8422 21.1073 27.0019 20.2538 27.0019C16.5472 27.0019 13.5425 23.9971 13.5425 20.2905C13.5425 16.584 16.5472 13.5792 20.2538 13.5792C23.6594 13.5792 26.4725 16.1158 26.9069 19.4028C29.0643 19.3809 31.2066 19.8856 33.1425 20.8884C34.9806 21.8405 35.5667 24.1892 34.3913 25.8932L29.8016 32.5473C28.4167 34.5551 25.3385 34.1424 24.5314 31.8407L22.6765 26.551ZM24.9592 21.2957C27.4801 20.834 30.0829 21.2231 32.3586 22.4019C33.2854 22.882 33.5809 24.0662 32.9882 24.9254L28.3985 31.5795C27.805 32.44 26.4858 32.2631 26.1399 31.2767L23.4768 23.6821C23.1108 22.6385 23.7635 21.5147 24.8513 21.3155L24.9592 21.2957Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIconPills);
export default __webpack_public_path__ + "static/media/patient-icon-pills.a328cfb07326d7aec014449573966ced.svg";
export { ForwardRef as ReactComponent };